import React from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
} from "chart.js";

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const EmployeeHeadcountChart = ({ series, categories }) => {
  // Add ref for the scrollable container
  const chartContainerRef = React.useRef(null);
  
  // Add useEffect to scroll to the end when component mounts
  React.useEffect(() => {
    if (chartContainerRef.current) {
      chartContainerRef.current.scrollLeft = chartContainerRef.current.scrollWidth;
    }
  }, [categories]); // Dependency on categories to re-scroll when data changes
  
  // High-contrast brand-friendly palette (keeps Nando's red as primary accent).
  const SERIES_COLORS = {
    "Current Employees": "#1AA8FB", // blue
    "New Employees": "#55CE63", // green
    "Attritions": "#D3001A", // brand red
  };
  const FALLBACK_COLORS = ["#1AA8FB", "#55CE63", "#D3001A", "#f59e0b", "#9368E9", "#02a8b5"];

  // Convert ApexCharts series format to Chart.js format
  const chartData = {
    labels: categories,
    datasets: series.map((serie, index) => ({
      label: serie.name,
      data: serie.data,
      borderColor: SERIES_COLORS[serie.name] || FALLBACK_COLORS[index % FALLBACK_COLORS.length],
      backgroundColor: SERIES_COLORS[serie.name] || FALLBACK_COLORS[index % FALLBACK_COLORS.length],
      pointBackgroundColor: SERIES_COLORS[serie.name] || FALLBACK_COLORS[index % FALLBACK_COLORS.length],
      pointBorderColor: "#ffffff",
      tension: 0.4, // for smooth curves
      borderWidth: 3,
      pointRadius: 5,
      pointHoverRadius: 7,
      fill: false,
    })),
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
      },
      tooltip: {
        mode: 'index',
        intersect: false,
        enabled: true,
      },
      datalabels: {
        align: 'top',

        display: function(context) {
          return context.dataset.data[context.dataIndex] !== 0;
        },
        font: {
          weight: 'bold',
          size: 12
        }
      }
    },
    scales: {
      y: {
        display: false,
        title: {
          display: true,
          text: 'Number of Employees'
        }
      },
      x: {
        ticks: {
          font: {
            size: 12
          },
          maxRotation: 45,
          minRotation: 45,
        }
      }
    }
  };

  // Calculate min width based on categories length to ensure proper horizontal scrolling
  const minChartWidth = Math.max(categories.length * 80, 300); // 80px per category with minimum of 300px
  
  return (
    <div 
      ref={chartContainerRef}
      style={{ 
        height: "290px", 
        overflowX: "auto", 
        overflowY: "hidden",
        paddingTop: "10px"
      }}>
      <div style={{ 
        minWidth: `${minChartWidth}px`, 
        height: "100%" 
      }}>
        <Line data={chartData} options={options} />
      </div>
    </div>
  );
};

export default EmployeeHeadcountChart;
